import _ from 'lodash';
import config from 'src/shared/config';
import axios from 'src/shared/utils/axios';
import DummyApi from '../dummyApi';
import { times } from '../api';
const PKI_API_ENABLED = config.servers.pki.enabled;
const PKI_API_URL = config.servers.pki.url;
export interface CertDto {
  expirationStatus: string;
  expirationTime: number;
  type: string;
}
export interface CertExpirationDto {
  certExpirationAlertDays: number;
  certs: CertDto[];
}
interface PkiApi {
  expiredCerts(): Promise<CertExpirationDto>;
}
class PkiServerApi implements PkiApi {
  async expiredCerts(): Promise<CertExpirationDto> {
    const resp = await axios.get(`${PKI_API_URL}/api/pki/policy/expiration`);
    return resp.data;
  }
}
const pkiApi = new PkiServerApi();
export default pkiApi;
